import request, { ResponseData } from '@/utils/request'
import { StoryType } from './components/StoryModal/const'
import { GroupsType, StorySearchParamsType, StroyListType, MockType } from './model'

// 获取分组
export async function fetchGroups(): Promise<ResponseData<GroupsType>> {
  return request('/api/v1/training/storycase', {
    method: 'get',
  })
}

// 获取案例内容
export async function getCaseGroups(): Promise<ResponseData<null>> {
  return request('/api/v1/training/dialogcase/group', {
    method: 'get',
  })
}

// 新增分组
export async function createGroup(params): Promise<ResponseData<null>> {
  const param = {
    group: {
      name: params?.name,
      parent_id: params.parent_id,
    },
  }
  return request('/api/v1/training/storycase', {
    method: 'post',
    data: param,
  })
}

// 删除分组
export async function deleteGroup(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/storycase', {
    method: 'delete',
    data: params,
  })
}

// 批量删除分组
export async function deleteGroups(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/storycase/group/batch/delete', {
    method: 'delete',
    data: params,
  })
}

// 修改分组
export async function updateGroup(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/storycase', {
    method: 'patch',
    data: params,
  })
}

// 移动分组
export async function dropGroup(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/storycase', {
    method: 'put',
    data: params,
  })
}

export async function fetchStories(
  params: StorySearchParamsType
): Promise<ResponseData<StroyListType>> {
  return request('/api/v1/training/storycase/list', {
    method: 'post',
    data: params,
  })
}

export async function createStory(params: StoryType): Promise<ResponseData<StroyListType>> {
  return request('/api/v1/training/storycase/create', {
    method: 'post',
    data: params,
  })
}

// 右边的编辑
export async function updateStory(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/storycase/update', {
    method: 'patch',
    data: params,
  })
}

// 右边的删除
export async function deleteStory(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/storycase/batch/delete', {
    method: 'post',
    data: {
      ids: params.dialog_ids,
    },
  })
}

// 移动到其他分组
export async function moveStory(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/storycase/move', {
    method: 'post',
    data: params,
  })
}

export function usersList(params) {
  return request('/api/v1/users/list', {
    method: 'post',
    data: params,
  })
}

// 新增剧本
export function addScreenplay(params) {
  return request('/api/v1/training/storycase/create_semi_auto', {
    method: 'post',
    data: params,
  })
}

export function generateStory() {
  return request('/api/v1/training/storycase/create_auto', {
    method: 'post',
  })
}

export function generateStart(params: { operation_id: string }) {
  return request('/api/v1/training/storycase/create_auto_start', {
    method: 'post',
    data: params,
  })
}

export function getGenerateProgress(params: { operation_id: string }) {
  return request('/api/v1/training/storycase/get_progress', {
    method: 'get',
    params,
  })
}

// 获取商品列表
export async function fetchGoodList(params) {
  return request('/api/v1/training/storycase/hot_product', {
    method: 'post',
    data: params,
  })
}

// 获取商品分类
export async function fetchBusinessType(params?) {
  return request('/api/v1/training/storycase/hot_product_classify', {
    method: 'post',
    data: params,
  })
}

// 获取商品标签
export async function fetchBusinessTag() {
  return request('/api/v1/training/storycase/hot_product_tags', {
    method: 'post',
  })
}

// 获取商品平台
export async function fetchPlatforms() {
  return request('/api/v1/training/storycase/hot_product_platforms', {
    method: 'post',
  })
}

// 获取商品店铺
export async function fetchShops(params?) {
  return request('/api/v1/training/storycase/hot_product_shops', {
    method: 'post',
    data: params,
  })
}

// 商品选择
export async function goodsSelection(params) {
  return request('/api/v1/training/storycase/hot_product', {
    method: 'post',
    data: params,
  })
}

// 自定义新增剧本名称重复
export async function checkRepeatName(params) {
  return request('/api/v1/training/storycase/repeat_name_verify', {
    method: 'post',
    data: params,
  })
}

// 导入商品
export async function importGoods(params) {
  return request('/api/v1/training/storycase/goods_excel_parse', {
    method: 'post',
    data: params,
  })
}

// 商品文件
export async function downGoodsFile(params) {
  return request('/api/v1/training/storycase/goods_excel_parse/export', {
    method: 'post',
    data: params,
    responseType: 'arrayBuffer',
    getResponse: true,
  })
}

// 买家需求背景、进线咨询流程重新生成
export async function rebuildStoryContent(params) {
  return request('/api/v1/training/storycase/story_content_rebuild', {
    method: 'post',
    data: params,
  })
}

// AI导师、精准质检重新生成
export async function rebuildAiMentor(params) {
  return request('/api/v1/training/dialog_result/result_content_rebuild', {
    method: 'post',
    data: params,
  })
}

// 使用deepseek获取重新生成深度思考
export async function getStreamResult(params) {
  return request('/api/v1/training/chat/get_stream_result', {
    method: 'post',
    data: params,
  })
}

// 查看商品详情
export async function fetchGoodsDetail(params) {
  return request('/api/v1/training/storycase/get_story', {
    method: 'post',
    data: params,
  })
}

// 模拟接待
export async function mockReception(params): Promise<ResponseData<MockType>> {
  return request('/api/v1/training/chat/ai_preview', {
    method: 'post',
    data: params,
  })
}

// 查询voc热门商品
export async function inquireVocHotGoods(params) {
  return request('/api/v1/training/dialogcase/voc/list_hot_goods', {
    method: 'post',
    data: params,
  })
}

// voc案例筛选
export async function vocCaseSelect(params) {
  return request('/api/v1/training/dialogcase/voc/dialog_case_selection', {
    method: 'post',
    data: params,
  })
}

// voc案例筛选进度查询
export async function vocCaseSelProgress(params) {
  return request('/api/v1/training/dialogcase/voc/get_progress?OperationId=' + params, {
    method: 'get',
  })
}

// voc案例展示
export async function showVocCase(params) {
  return request('/api/v1/training/dialogcase/voc/dialog_case', {
    method: 'post',
    data: params,
  })
}

// 编辑剧本设置订单
export async function setSimulatedOrders(params) {
  return request('/api/v1/training/storycase/order/remark_update', {
    method: 'post',
    data: params,
  })
}

// 图片解析
export async function parsePic(params) {
  return request('/api/v1/sys/pic/parse', {
    method: 'post',
    data: params,
  })
}

// 保存资源文件
export async function saveResource(params) {
  return request('/api/v1/sys/resource/save', {
    method: 'post',
    data: params,
  })
}

// 查询资源文件
export async function queryResource(params) {
  return request('/api/v1/sys/resource/query', {
    method: 'post',
    data: params,
  })
}
